import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-item-dossier-detail-modal',
  templateUrl: './item-dossier-detail-modal.component.html',
  styleUrls: ['./item-dossier-detail-modal.component.scss']
})
export class ItemDossierDetailModalComponent implements OnInit {

  public itemDossierDetailForm: FormGroup = this.formBuilder.group({
    nomeDocumento: [null],
    docPrincipale: [null],
    idDocumento: [null],
    dataProtocollo: [null],
    oggettoProtocollo: [null],
    mittente: [null],
    destinatario: [null]
  });
  
  ngOnInit() {}

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ItemDossierDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header : string, itemDossier : any }) {

      this.itemDossierDetailForm.get('nomeDocumento')
        .patchValue(data.itemDossier && data.itemDossier.nome ? data.itemDossier.nome : ' ');

      this.itemDossierDetailForm.get('docPrincipale')
        .patchValue(data.itemDossier && data.itemDossier.principale ? 'SI' : 'NO');

      this.itemDossierDetailForm.get('idDocumento')
        .patchValue(data.itemDossier && data.itemDossier.itemDocIndex && data.itemDossier.itemDocIndex.idDocumentoProtocollo 
          ? data.itemDossier.itemDocIndex.idDocumentoProtocollo : ' ');

      this.itemDossierDetailForm.get('dataProtocollo')
        .patchValue(data.itemDossier && data.itemDossier.dataInserimentoFile ? data.itemDossier.dataInserimentoFile : ' ');

      this.itemDossierDetailForm.get('oggettoProtocollo')
        .patchValue(data.itemDossier && data.itemDossier.itemDocIndex && data.itemDossier.itemDocIndex.oggettoProtocollo 
          ? data.itemDossier.itemDocIndex.oggettoProtocollo : ' ');

      this.itemDossierDetailForm.get('mittente')
        .patchValue(data.itemDossier && data.itemDossier.mittente ? data.itemDossier.mittente : ' ');

      this.itemDossierDetailForm.get('destinatario')
        .patchValue(data.itemDossier && data.itemDossier.destinatario ? data.itemDossier.destinatario : ' ');

      this.itemDossierDetailForm.disable();
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
